import React from 'react';
import { PERIOD_DAYS } from './contract';

const presets = [
  ...PERIOD_DAYS.map((days) => ({ key: `DAYS-${days}`, label: `${days} dias`, days })),
  { key: 'ALL', label: 'Todos' },
];
const presetKey = (period) =>
  period.type === 'DAYS' ? `DAYS-${period.days}` : period.type === 'ALL' ? 'ALL' : null;

/** Período rápido e intervalo são exclusivos: um botão limpa as datas; uma data desmarca os botões. */
export default function PeriodField({ id, value, onChange, suffix = '', hint }) {
  const active = presetKey(value);
  const from = value.type === 'RANGE' ? value.from || '' : '';
  const to = value.type === 'RANGE' ? value.to || '' : '';
  const setRange = (nextFrom, nextTo) =>
    onChange(
      nextFrom || nextTo
        ? { type: 'RANGE', from: nextFrom || null, to: nextTo || null }
        : { type: 'ALL' },
    );
  // O sufixo fica só no período rápido; a regra das datas vai no texto de apoio (hint).
  const label = suffix ? ` (${suffix})` : '';
  return (
    <div className="tc-f-period" data-filter-field={id}>
      <div className="tc-f-field">
        <span className="tc-f-label" id={`${id}-quick`}>
          Período rápido{label}
        </span>
        <div className="tc-f-presets" role="group" aria-labelledby={`${id}-quick`}>
          {presets.map((preset) => (
            <button
              key={preset.key}
              type="button"
              aria-pressed={active === preset.key}
              onClick={() =>
                onChange(preset.days ? { type: 'DAYS', days: preset.days } : { type: 'ALL' })
              }
            >
              {preset.label}
            </button>
          ))}
        </div>
      </div>
      <div className="tc-f-range">
        <div className="tc-f-field">
          <label htmlFor={`${id}-from`}>Data inicial</label>
          <input
            id={`${id}-from`}
            type="date"
            value={from}
            max={to || undefined}
            onChange={(e) => {
              const day = e.target.value;
              // Data inicial depois da final descarta a final, em vez de gerar um intervalo vazio.
              setRange(day, to && day && day > to ? '' : to);
            }}
          />
        </div>
        <div className="tc-f-field">
          <label htmlFor={`${id}-to`}>Data final</label>
          <input
            id={`${id}-to`}
            type="date"
            value={to}
            min={from || undefined}
            onChange={(e) => {
              const day = e.target.value;
              setRange(from && day && day < from ? '' : from, day);
            }}
          />
        </div>
      </div>
      {hint && <small>{hint}</small>}
    </div>
  );
}
